import { jsx as _jsx } from "react/jsx-runtime";
import { AppRouter } from '@routes/AppRouter';
import { BrowserRouter } from 'react-router-dom';
function App() {
    return (_jsx(BrowserRouter, { children: _jsx(AppRouter, {}) }));
}
export default App;
